import { Select, message } from "antd"
import { Modal } from "antd"
import dayjs from "dayjs"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import styled from "styled-components"

import { deleteBookingAsAdmin } from "../../../../../../../api"
import AppSelect from "../../../../../../_shared/components/FormItems/AppSelect"
import { useStateValue } from "../../../../../../_shared/context/AppStateStore"
import { uniqueFilter } from "../../../../../../_shared/toolbox"
import Slot from "./Slot"

// ----------------------------------------------------------------------------

function _SlotForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------
    const { values, onValueChange } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [dateFilter, setDateFilter] = useState("all")
    const [locationFilter, setLocationFilter] = useState("all")
    const [filteredSlots, setFilteredSlots] = useState([])
    const [{ token }] = useStateValue()

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        let filtered =
            values?.slots?.map((slot, originalIndex) => ({
                ...slot,
                originalIndex,
            })) ?? []
        if (dateFilter !== "all") {
            filtered = filtered.filter((slot) => slot.date === dateFilter)
        }
        if (locationFilter !== "all") {
            filtered = filtered.filter(
                (slot) => slot.locationCode === locationFilter
            )
        }
        setFilteredSlots(filtered)
        //eslint-disable-next-line
    }, [locationFilter, dateFilter, values?.slots])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function renderDateSelectOptions() {
        return getUniqueDates()?.map((date) => (
            <Select.Option key={date} value={date}>
                {dayjs(date).format("DD MMMM YYYY")}
            </Select.Option>
        ))
    }
    function renderLocationSelectOptions() {
        return values.locations?.map((l) => (
            <Select.Option key={l.code} value={l.code}>
                {l.address}, {l.city} ({l.province})
            </Select.Option>
        ))
    }

    function deleteSlotBooking(booker, slot) {
        return () => {
            async function execute() {
                try {
                    const { id: bookingId } = booker
                    await deleteBookingAsAdmin(bookingId, token)
                    const handler = onValueChange("slots")
                    const newSlots = values?.slots?.map((s) => {
                        if (s.id === slot.id) {
                            return { ...s, booker: null }
                        } else {
                            return s
                        }
                    })
                    handler(newSlots)
                    message.success("Prenotazione eliminata.")
                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e)
                    message.error(
                        "Non è stato possibile eliminare la prenotazione."
                    )
                }
            }
            Modal.confirm({
                onOk: execute,
                content:
                    "Sei sicuro di voler eliminare questa prenotazione? Questa azione risulterà nell'eliminazione permanente della prenotazione anche qualora non si salvino le modifiche all'evento.",
                title: "Conferma operazione",
            })
        }
    }

    function getUniqueDates() {
        return values?.slots?.map((slots) => slots?.date).filter(uniqueFilter)
    }

    function updateSlot(index) {
        return (field, value) => {
            const newSlots = [...values.slots]
            newSlots[index][field] = value
            onValueChange("slots")(newSlots)
        }
    }

    function renderSlots() {
        return filteredSlots?.map((slot) => {
            const location = values?.locations?.find(
                (l) => l.code === slot.locationCode
            )
            return (
                <Slot
                    className="slot"
                    key={slot.id || slot.tempId}
                    slot={slot}
                    location={location}
                    onChange={updateSlot(slot.originalIndex)}
                    onDeleteBooking={deleteSlotBooking(slot.booker, slot)}
                ></Slot>
            )
        })
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------
    // -------------------------------------

    return (
        <div className={props.className}>
            <div className="filters">
                <AppSelect value={dateFilter} onChange={setDateFilter}>
                    <Select.Option value="all">Tutte le date</Select.Option>
                    {renderDateSelectOptions()}
                </AppSelect>
                <AppSelect value={locationFilter} onChange={setLocationFilter}>
                    <Select.Option value="all">Tutte le location</Select.Option>
                    {renderLocationSelectOptions()}
                </AppSelect>
            </div>
            <div className="slots">{renderSlots()}</div>
            {/* {renderAddSlot()} */}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_SlotForm.propTypes = {
    className: PropTypes.string.isRequired,
    values: PropTypes.object,
    onValueChange: PropTypes.func,
    reloadEvent: PropTypes.func,
}

_SlotForm.defaultProps = {
    reloadEvent: () => {},
}

// ----------------------------------------------------------------------------

const SlotForm = styled(_SlotForm)`
    & {
        width: 100%;
        .filters {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 20px;
        }
        .slots {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 15px;
        }
    }
`
// ----------------------------------------------------------------------------

export default SlotForm
